import React from "react";
import { useSelector } from "react-redux";
import Style from "./Networking.module.scss";
import { NetworkingCard } from "./NetworkingCard";

const AuthNetworking: React.FC = () => {
  const netwDays = useSelector((state) => state.Networking?.Days.data);

  return (
    <div className={Style.container}>
      <div className={Style.inner}>
        <div className={Style.block}>
          <div className={Style.header}>
            <div className={Style.titles}>
              <p className={Style.subtitle}>Ищете партнеров в турбизнесе?</p>
              <p className={Style.title}>
                <span>Нетворкинг</span> – это раздел, где можно обменяться
                визитками, чтобы найти партнеров
              </p>
              <p className={Style.hint}>
                Работать в системе Вы сможете сразу после подключения опции. 
              </p>
            </div>

            <img src={require("@public/images/computer.svg")} alt="Компьютер" />
          </div>
          <div className={Style.cards}>
            <NetworkingCard
              number="1"
              title="Найдите партнеров в туризме"
              text="Знакомьтесь с представителями компаний и заключайте контракты"
            />

            {netwDays.length > 0 && (
              <NetworkingCard
                number="2"
                title="Назначайте видеовстречи"
                text="Обсуждайте детали сотрудничества и нюансы продажи и
                  организации туров по России"
              />
            )}

            <NetworkingCard
              number={netwDays.length ? "3" : "2"}
              title="Выбирайте компании по своим критериям"
              text="Используйте фильтры системы, чтобы быстро найти нужные связи"
            />

            <NetworkingCard
              number={netwDays.length ? "4" : "3"}
              title="Обменивайтесь визитками"
              text="Контакты ТИЦ, туроператоров, отелей и объектов показа будут под
                рукой во время выставки"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthNetworking;
